import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import AppLayout from './layout/AppLayout.jsx'
import Home from './pages/Home.tsx'
import Places from './pages/Places.tsx'
import Place from './pages/Place.tsx'
import People from './pages/People.tsx'
import Person from './pages/Person.tsx'
import ChatHub from './pages/Chat.tsx'
import ChatThread from './pages/ChatThread.tsx'
import GuestChat from './pages/GuestChat.tsx'
import Shop from './pages/Shop.tsx'
import News from './pages/News.tsx'
import PlatformOverviewPage from './pages/Lab.tsx'
import About from './pages/About.tsx'
import PrivacyPolicy from './pages/PrivacyPolicy.tsx'
import TermsOfUse from './pages/TermsOfUse.tsx'
import Impressum from './pages/Impressum.tsx'
import UserSettings from './pages/UserSettings.tsx'
import CookieBanner from './components/CookieBanner.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { ChatProvider } from './chat/state/chatStore'
import RequireAuth from './auth/RequireAuth'
import Dashboard from './pages/Dashboard.tsx'
import Login from './pages/Login.tsx'
import Register from './pages/Register.tsx'

const LazyPlacesTimeMap = lazy(() => import('./pages/PlacesTimeMap.tsx'))

const App = () => {
  return (
    <>
      <AppLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/places" element={<Places />} />
          <Route
            path="/places/time-map"
            element={(
              <Suspense fallback={<div className="route-loading">Loading map…</div>}>
                <LazyPlacesTimeMap />
              </Suspense>
            )}
          />
          <Route path="/places/:slug" element={<Place />} />
          <Route path="/people" element={<People />} />
          <Route path="/people/:slug" element={<Person />} />
          <Route path="/figures/quotha" element={<Navigate to="/people/quotha" replace />} />
          <Route path="/chat" element={<ChatHub />} />
          <Route
            path="/chat/:threadId"
            element={
              <RequireAuth>
                <ChatThread />
              </RequireAuth>
            }
          />
          <Route path="/chat/choose" element={<Navigate to="/people" replace />} />
          <Route
            path="/guest/:slug"
            element={
              <ChatProvider>
                <GuestChat />
              </ChatProvider>
            }
          />
          <Route
            path="/guest"
            element={
              <ChatProvider>
                <GuestChat />
              </ChatProvider>
            }
          />
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/register"
            element={<Register />}
          />
          <Route
            path="/chat-app"
            element={<Navigate to="/dashboard" replace />}
          />
          <Route path="/shop" element={<Shop />} />
          <Route path="/news" element={<News />} />
          <Route path="/platform-overview" element={<PlatformOverviewPage />} />
          <Route path="/lab" element={<Navigate to="/platform-overview" replace />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <ErrorBoundary>
                  <Dashboard />
                </ErrorBoundary>
              </RequireAuth>
            }
          />
          <Route path="/settings" element={<UserSettings />} />
          <Route path="/privacy-policy-gdpr" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </AppLayout>
      <CookieBanner />
    </>
  )
}

export default App
